import { Inject } from '@odinjs/odin';

import { Endpoint, IeAnexo, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FieldAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { MensagemDetalhesAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { Anexo } from './mensagem-controller';
import './mensagem-detalhes-controller.css';

@Controller({ fragment: FragmentNames.MENSAGEM_DETALHES })
export default class MensagemDetalhesController extends BaseController {

  @Inject(Aliases.FIELD_ANEXOS)
  private fieldAnexos: FieldAPI;

  @OnMount(Aliases.CONTEXTUAL_BAR_MENSAGEM)
  onMountContextualBarDetalhesMensagem(): void {
    const { nrSeqComunicado } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqComunicado });
  }

  @OnSelect(Aliases.LISTA_ANEXOS)
  onSelectAnexo({ value }: SelectEvent<Anexo>): void {
    const { nrSeqAnexo, nmAnexo } = value;
    const ieTabela = IeAnexo.MENSAGEM_ANEXO;

    FileService.download(Endpoint.GET.MENSAGENS_ANEXO_DOWNLOAD, nmAnexo, { ieTabela, nrSeqAnexo }, HttpMethod.GET)
      .catch(() => ToastServiceStipulator.error(MessageService.translate('stipulator.arquivo-nao-localizado')));
  }

  @OnAfterFetch(Aliases.FETCH_ANEXOS)
  onAfterFetchAnexos(event: FetchEvent): void {
    if (event.data) {
      const data = event.data as FetchAPI;
      if (data.length > 0) {
        this.fieldAnexos.setLabel(MessageService.translate('stipulator.anexos'));
      }
    }
  }

}
